<div class="row" style="width: 100%; margin: 10px 0px">
    <div class="col-md-12 pt-3">
        <div class="row">
            <div class="col-md-3 select-activity-pack-title">
                <h3 class="mb-0">Select Activity Pack Types</h3>
            </div>
            <div class="col-md-9 d-flex justify-content-end align-items-center">
                <app-instance-info-section></app-instance-info-section>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 d-flex justify-content-end align-items-center">
                <button type="button" class="btn primary-ebtn me-3" onclick="" (click)="createActivityPackType()">Create Activity Pack Type</button>
            </div>
        </div>
    </div>
    <div class="row" style="width: 100%; margin: 10px 0px">
        <ng-container *ngIf="defaultActivityPackTypeList && defaultActivityPackTypeList.length > 0">
            <div class="col-md-2 col-md-3 mt-4 mb-4 files-card-view" *ngFor="let type of defaultActivityPackTypeList; let i = index">
                <div class="card_gridFour">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-9 d-flex flex-row align-items-center">
                                    <div class="activity-checkbox">
                                        <mat-checkbox
                                            class="checkbox-wrap"
                                            [checked]="type.isSelected"
                                            [disabled]="type.isTaggedItemLocal && type.isSelected"
                                            (change)="checkUncheckActivityPackType($event, type)"
                                        ></mat-checkbox>
                                    </div>
                                    <div class="card_grid_heading-right">
                                        <h4 class="card_grid_heading_title px-3 m-0">{{ type.name }}</h4>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="gridleft_symbols d-flex align-items-center me-3 h-100">
                                        <div class="eye-icon" (click)="openViewActivityTypeModal(type)">
                                            <!-- <i class="far fa-eye" matTooltip="View"></i> -->
                                            <mat-icon #tooltip="matTooltip" matTooltip="View" class="mat-icon-view"> remove_red_eye </mat-icon>
                                        </div>
                                        <div class="delete-icon">
                                            <!-- <i class="far fa-trash-alt" matTooltip="Delete"
                                                (click)="deleteActivityPackType(type)"></i> -->
                                            <mat-icon
                                                #tooltip="matTooltip"
                                                class="mat-icon-delete"
                                                matTooltip="Delete"
                                                [matTooltipPosition]="tooltip_position"
                                                (click)="deleteActivityPackType(type)"
                                                >delete</mat-icon
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="card_grid_body d-flex flex-row justify-content-between">
                                <div class="activity-pack-description">
                                    <p class="m-0">{{ type.description }}</p>
                                </div>
                                <div class="activity-pack-type-logo" *ngIf="type.icon">
                                    <img [src]="type.icon" alt="types" />
                                </div>
                                <div class="activity-pack-type-logo" *ngIf="!type.icon">
                                    <!-- <ngx-avatars [name]="type.name" initialsSize="3" size="30" bgColor="#ffcc01"
                                        fgColor="#3F4254"></ngx-avatars> -->
                                    <div
                                        class="custom-avatar"
                                        [ngStyle]="{
                                            width: '30px',
                                            height: '30px',
                                            backgroundColor: '#ffcc01',
                                            color: '#3F4254',
                                            fontSize: '13px',
                                            borderRadius: '50%',
                                        }"
                                    >
                                        {{ getInitials(type.name) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="no-type d-flex align-items-center justify-content-center w-100" *ngIf="defaultActivityPackTypeList.length <= 0">
        <h3>No Activity Pack Type Available</h3>
    </div>
</div>
